import React from "react";
import './Announcement.css'

const Announcement = () => {
  return (
    <div className="announcement-container">
      <h1>Free Delivery</h1>
      <h1>Welcome offer 15% off</h1>
      <h1>Free Returns</h1>
    </div>
  );
};

export default Announcement;
